export const JOURNEY_STOPS = [
  { id: "home", camera: [0, 0.72, 8.4], target: [0, -0.08, -3.5], fov: 41 },
  { id: "experience", camera: [1.05, 0.5, 6.15], target: [2.62, -0.25, -4.2], fov: 35 },
  { id: "research", camera: [0.55, 0.86, 5.65], target: [1.7, 0.06, -4.75], fov: 36 },
  { id: "projects", camera: [1.45, 0.48, 4.75], target: [2.62, 0.08, -4.0], fov: 34 },
  { id: "skills", camera: [0.18, 0.76, 5.7], target: [1.85, 0.02, -4.55], fov: 37 },
  { id: "testimonials", camera: [0.78, 0.62, 5.2], target: [1.85, -0.08, -4.3], fov: 35 },
  { id: "contact", camera: [0.25, 0.42, 7.3], target: [1.48, -0.28, -5.2], fov: 42 },
];

export const JOURNEY_IDS = JOURNEY_STOPS.map((stop) => stop.id);

const mix = (start, end, amount) => start + (end - start) * amount;
const mixVector = (start, end, amount) => start.map((value, index) => mix(value, end[index], amount));
const smoothstep = (amount) => amount * amount * (3 - 2 * amount);

const getSegment = (progress, markers) => {
  const ordered = markers
    .map((marker) => ({ ...marker, pose: JOURNEY_STOPS.find((stop) => stop.id === marker.id) }))
    .filter((marker) => marker.pose)
    .sort((a, b) => a.progress - b.progress);

  if (!ordered.length) return { start: { ...JOURNEY_STOPS[0], progress: 0, pose: JOURNEY_STOPS[0] }, end: null, amount: 0 };
  const endIndex = ordered.findIndex((marker) => marker.progress >= progress);
  const nextIndex = endIndex === -1 ? ordered.length - 1 : endIndex;
  const end = ordered[nextIndex];
  const start = ordered[Math.max(0, nextIndex - 1)];
  if (start === end) return { start, end: null, amount: 0 };
  const raw = Math.min(1, Math.max(0, (progress - start.progress) / Math.max(end.progress - start.progress, 0.001)));
  return { start, end, amount: smoothstep(raw) };
};

export const getJourneyState = (progress, markers) => {
  const { start, end, amount } = getSegment(Math.min(1, Math.max(0, progress)), markers);
  if (!end) {
    return {
      camera: start.pose.camera,
      target: start.pose.target,
      fov: start.pose.fov,
      focus: { [start.id]: 1 },
      activeId: start.id,
    };
  }

  return {
    camera: mixVector(start.pose.camera, end.pose.camera, amount),
    target: mixVector(start.pose.target, end.pose.target, amount),
    fov: mix(start.pose.fov, end.pose.fov, amount),
    focus: { [start.id]: 1 - amount, [end.id]: amount },
    activeId: amount < 0.5 ? start.id : end.id,
  };
};

export const measureJourneyMarkers = () => {
  const maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
  return JOURNEY_STOPS.map((stop, index) => {
    if (index === 0) return { id: stop.id, progress: 0 };
    const section = document.getElementById(stop.id);
    if (!section) return { id: stop.id, progress: index / (JOURNEY_STOPS.length - 1) };
    const sectionTop = section.getBoundingClientRect().top + window.scrollY;
    const focusOffset = Math.min(section.offsetHeight * 0.02, 18);
    return { id: stop.id, progress: Math.min(1, Math.max(0, (sectionTop + focusOffset) / maxScroll)) };
  });
};

export const getDeviceProfile = (width, deviceMemory = 8) => {
  const compact = width < 720;
  const medium = width >= 720 && width < 1100;
  const constrained = compact || deviceMemory <= 4;
  return {
    compact,
    medium,
    constrained,
    pixelRatioCap: compact ? 1 : constrained ? 1.15 : 1.35,
    starCount: compact ? 36 : constrained ? 58 : 92,
    ridgeSegments: compact ? 12 : constrained ? 16 : 24,
    planetDetail: constrained ? 1 : 2,
  };
};
